<!--BackToAct-->

<template>
  <van-button v-if="redirectInCardsPage" class="BackToAct-btn" block round type="info" @click="go_act">立即兑换</van-button>
</template>

<style scoped>
.BackToAct-btn {
  width: 90vw;
  position: fixed;
  bottom: 5vw;
  left: 5vw;
}
</style>

<script>
export default {
  data() {
    return {
      redirectInCardsPage: null
    }
  },

  mounted() {
    this.redirectInCardsPage = sessionStorage.getItem("budo.redirect-in-cards-page") // 绑卡后跳转回本页面
    sessionStorage.removeItem("budo.redirect-in-cards-page")
  },

  methods: {
    go_act() {
      location.href = this.redirectInCardsPage
    }
  }
}
</script>